import { isNull } from 'lodash';
import React from 'react';
import { useSearchParams } from 'react-router-dom';

export const useTabHandler = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  return {
    currentTab: +(searchParams.get('tab') || '0'),
    setTab: React.useCallback(
      (newTab: number) => {
        const readonly = searchParams.get('readonly');
        const newParams: { tab: string; readonly?: string } = {
          tab: newTab?.toString(),
        };

        if (!isNull(readonly)) {
          newParams.readonly = readonly;
        }

        return setSearchParams(newParams);
      },
      [searchParams]
    ),
  };
};
